import { computed } from 'vue'
import { getRouteSeoKeys, normalizeRoutePath } from '~/constants/routeSeoKeys'
import {
  resolveRewardShareImageType,
  resolveRewardShareImageUrl,
} from '~/constants/rewardShare'
import { resolveSeoText, SITE_SEO_KEYS } from '~/utils/resolveSeoText'

/** 全站 TDK：路由映射 → 页面 SEO i18n → site.seo 兜底 */
export function useRoutePageSeo() {
  const route = useRoute()
  const config = useRuntimeConfig()
  const { t, te, tm } = useI18n()

  const normalizedPath = computed(() => normalizeRoutePath(route.path))
  const pageSeoKeys = computed(() => getRouteSeoKeys(normalizedPath.value))

  const title = computed(() => {
    const keys = pageSeoKeys.value
    return resolveSeoText(
      t,
      te,
      tm,
      keys?.titleKey,
      SITE_SEO_KEYS.title,
    )
  })

  const description = computed(() => {
    const keys = pageSeoKeys.value
    return resolveSeoText(
      t,
      te,
      tm,
      keys?.descriptionKey,
      SITE_SEO_KEYS.description,
    )
  })

  const keywords = computed(() => {
    const keys = pageSeoKeys.value
    return resolveSeoText(
      t,
      te,
      tm,
      keys?.keywordsKey,
      SITE_SEO_KEYS.keywords,
    )
  })

  const homeSocialTitle = computed(() => normalizedPath.value === '/' ? title.value : undefined)
  const homeSocialDescription = computed(() => (
    normalizedPath.value === '/' ? description.value : undefined
  ))
  const homeSocialImage = computed(() => (
    normalizedPath.value === '/'
      ? resolveRewardShareImageUrl(
          config.public.rewardShareImageUrl,
          config.public.baseUrl,
        )
      : undefined
  ))
  const homeSocialImageType = computed(() => (
    normalizedPath.value === '/'
      ? resolveRewardShareImageType(homeSocialImage.value)
      : undefined
  ))

  useHead({
    title,
    meta: [
      { name: 'description', content: description },
      { name: 'keywords', content: keywords },
      { property: 'og:type', content: computed(() => normalizedPath.value === '/' ? 'website' : undefined) },
      { property: 'og:title', content: homeSocialTitle },
      { property: 'og:description', content: homeSocialDescription },
      { property: 'og:image', content: homeSocialImage },
      { property: 'og:image:secure_url', content: homeSocialImage },
      { property: 'og:image:type', content: homeSocialImageType },
      { property: 'og:image:width', content: computed(() => normalizedPath.value === '/' ? '768' : undefined) },
      { property: 'og:image:height', content: computed(() => normalizedPath.value === '/' ? '432' : undefined) },
      { property: 'og:image:alt', content: homeSocialTitle },
      { name: 'twitter:card', content: computed(() => normalizedPath.value === '/' ? 'summary_large_image' : undefined) },
      { name: 'twitter:title', content: homeSocialTitle },
      { name: 'twitter:description', content: homeSocialDescription },
      { name: 'twitter:image', content: homeSocialImage },
      { name: 'twitter:image:alt', content: homeSocialTitle },
    ],
  })
}
